import React from 'react';
import { useActor } from '@xstate/react';
import CaseCheckout from '../case/CaseCheckout';
import SubmitCaseViewProps from '../submitCase/types/SubmitCaseViewProps';
import { useEditCaseContext } from '../../context/EditCaseContext';
import { PaymentType } from '../../stateMachines/submitCase/selectPaymentType';
import FullscreenLoader from '../common/FullscreenLoader';

interface CheckoutProps extends SubmitCaseViewProps {}

const Checkout: React.FC<CheckoutProps> = ({ ...props }) => {
  const { editCaseService } = useEditCaseContext();
  const [state, send] = useActor(editCaseService);

  const { caseInfo, uploadProgress } = state.context;

  const isLoading = state.matches({ checkout: 'load' }) ||
                    state.matches({ checkout: 'ensureSetupIntent' }) ||
                    state.matches({ checkout: 'confirmingSetupIntent' });
  const isSubmitting = state.matches({ checkout: 'submitCase' });

  if (!caseInfo) {
    return null;
  }

  if (isLoading || !state.context.lineItems || state.context.totalPrice === undefined) {
    return <FullscreenLoader show={true} />;
  }

  return (
    <FullscreenLoader show={isLoading}>
      <CaseCheckout
        caseUserId={state.context.userId}
        clinicName={state.context.name}
        clinicEmail={state.context.email}
        invoicingEnabled={state.context.paymentType === PaymentType.INVOICE}
        parentAccount={state.context.parentAccount}
        onSubmit={() => send('NEXT')}
        onBack={() => send('BACK')}
        caseInfo={caseInfo}
        isSubmitting={isSubmitting}
        progress={uploadProgress}
        submitText="Update Case"
        selectedInvoiceAccountUid={state.context.selectedInvoiceAccountUid}
        lineItems={state.context.lineItems || []}
        total={state.context.totalPrice || 0}
        priorityUpgradePrice={state.context.priorityUpgradePrice || 0}
        error={state.context.error}
      />
    </FullscreenLoader>
  );
};

export default Checkout;
